import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";
import { useToast } from '@/hooks/use-toast';
import type {Vel} from '@/types/Vel';

const patchVel = async (velId, body: Partial<Vel>) => {
  const { data } = await axiosInstance.patch(
    `/api/abo/vel/${velId}`,
    body
  );
  return data;
};

export const useVelPatch = ({velId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<Vel>) =>
      patchVel(velId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['vel'],
      });
      toast({
        variant: "default",
        title: "Votre offre a été mise à jour",
      });
    },
    onError: (e) => {
      console.error('ERROR PATCH', e)
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};
